import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'antd/lib/checkbox';
import { accountRoles, accountRolesT } from '../../../../common/enums';

const { Group: CheckboxGroup } = Checkbox;

const rolesFilterOptions = [
  { label: accountRolesT.CREDITOR, value: accountRoles.CREDITOR },
  { label: accountRolesT.DEBTOR, value: accountRoles.DEBTOR },
];

const Role = ({ value, onChange }) => {
  return <CheckboxGroup options={rolesFilterOptions} value={value} onChange={onChange} />;
};

Role.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Role;



// WEBPACK FOOTER //
// ./src/features/account-management/components/filters/Role.js